import React from 'react'

import { Box } from '@domain-group/suit-theme'

import Footer from './Footer'
import Items from './Items'

interface OrderContainerProps {
  children: React.ReactNode,
}

const OrderContainer = (props: OrderContainerProps) => {
  const { children } = props

  return (
    <Box
      backgroundColor="white"
      border="1px solid"
      borderColor="lineColor"
      borderRadius={5}
      flexDirection="column"
      marginBottom="large"
    >
      {children}
    </Box>
  )
}

OrderContainer.Footer = Footer
OrderContainer.Items = Items

export default OrderContainer
